import AbstractPromotionsService from './abstract-promotions-service';
import PromotionsDataDescriptor from 'services/promotions/descriptor.js';
import promotionsProvider from 'services/promotions/provider';
import channelFactory from 'services/common/content/content-channel-factory.js';

export const getPromotionsChannel = () =>
    channelFactory.getChannel(promotionsProvider, PromotionsDataDescriptor.DATA_TYPES.PROMOTIONS);

/**
 * Class offering the possibility access promotions storable using push messaging mechanism.
 *
 * @class PushPromotionsService
 * @extends Mojito.Services.Promotions.AbstractPromotionsService
 * @memberof Mojito.Services.Promotions
 */
export default class PushPromotionsService extends AbstractPromotionsService {
    subscribe(options, onMessage) {
        const { clientId, channels } = options;
        getPromotionsChannel().subscribe(channels, clientId, onMessage);
    }

    unsubscribe(options) {
        const { clientId, channels } = options;
        getPromotionsChannel().unsubscribe(channels, clientId);
    }

    reset() {
        getPromotionsChannel().dispose();
    }
}

/**
 * PushPromotionsService class instance.
 *
 * @name pushPromotionsService
 * @memberof Mojito.Services.Promotions
 */
export const pushPromotionsService = new PushPromotionsService();
